export interface OverviewStatsCacheType {
    type: 'OverviewStats';
    id: 'ALL' | number; //project year
}

export const OverviewStatsCache: OverviewStatsCacheType = {
    type: 'OverviewStats',
    id: 'ALL',
};
